import { ElementType, Suspense, lazy, useEffect, useState } from 'react'
import { RouteObject, useRoutes } from 'react-router-dom'
import AmeSpin from './components/AmeSpin/AmeSpin'
import { PAGE_LINKS } from './helpers/commonConsts'
import { routerService } from './services/routerService'
import { userService } from './services/userService'

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<AmeSpin fullscreen={true} />}>
      <Component {...props} />
    </Suspense>
  )

const HomePage = Loadable(lazy(() => import('./pages/HomePage/HomePage')))
const LoginPage = Loadable(lazy(() => import('./pages/LoginPage/LoginPage')))

export type RouteObjectWithMeta = Omit<RouteObject, 'children'> & {
  auth?: boolean
  meta?: {
    title: string
  }
  children?: RouteObjectWithMeta[]
}

const AuthRoute = ({ children }: { children: React.ReactNode }) => {
  const [canRender, setRenderFlag] = useState(false)
  useEffect(() => {
    if (!userService.isLogin) {
      routerService.navigateTo('login', {
        redirectUrl: encodeURIComponent(window.location.href),
      })
      return
    }
    setRenderFlag(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return canRender ? children : null
}

const checkAuth = (routeList: RouteObjectWithMeta[]) => {
  return routeList.map((route) => {
    if (route.children) {
      route.children = checkAuth(route.children)
    }
    if (route?.auth) {
      route.element = <AuthRoute>{route.element}</AuthRoute>
    }
    return route
  })
}

const routes: RouteObjectWithMeta[] = [
  {
    path: PAGE_LINKS.home,
    element: <HomePage />,
    auth: true,
  },
  {
    path: PAGE_LINKS.login,
    element: <LoginPage />,
  },
]

export const Router = () => {
  return useRoutes(checkAuth(routes) as RouteObject[])
}
